import * as React from 'react'

import {
    Box,
    ListItem,
    useMediaQuery
} from '@mui/material'

import Araujo from '../../../../assets/images/Logos/Clientes/logo_araujo.png';
import ColegioArnaldo from '../../../../assets/images/Logos/Clientes/logo_colegio_arnaldo.png';
import UNA from '../../../../assets/images/Logos/Clientes/logo_una.png';
import UNE from '../../../../assets/images/Logos/Clientes/logo_une.png';
import Vilma from '../../../../assets/images/Logos/Clientes/logo_vilma.png';


import { Navigation, Pagination, Scrollbar, A11y, Autoplay  } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

import { ItemText } from '../../../itemText';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { BaseDiv } from './styles'
import { useRef, useState } from 'react'
import { useIntersection } from 'react-use'


const CarrouselClientes: React.FC = () => {
    const matches = useMediaQuery('(max-width:1000px)');
    const swiperRef = useRef<any>(null);

    const carouselRef = useRef<HTMLDivElement>(null);

    const [isVisible, setIsVisible] = useState(false);

    const intersection = useIntersection(carouselRef, {
    root: null,
    rootMargin: '200px', // Ativa 200px antes de entrar no viewport
    threshold: 0.1, // Ativa quando 10% do elemento está visível
    });

    React.useEffect(() => {
    if (intersection?.isIntersecting) {
      setIsVisible(true);
      if (swiperRef.current) {
        swiperRef.current.autoplay?.start(); // Inicia o autoplay
      }
    } else {
      setIsVisible(false);
      if (swiperRef.current) {
        swiperRef.current.autoplay?.stop(); // Para o autoplay
      }
    }
  }, [intersection]);


    const dados = [
        {image:Araujo},
        {image:ColegioArnaldo},
        {image:UNA},
        {image:UNE},
        {image:Vilma},
    ]

    return (
        <BaseDiv id='cli'>
            <Box
                sx={{
                    width: '90%',
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center"   
                }}
                ref={carouselRef}
            >
                <ListItem
                    sx={{
                        padding: 1,
                        flexDirection: 'row', 
                        textAlign: "center"                      
                    }}
                >
                    <ItemText 
                        primary="CLIENTES"
                        hideSecondary 
                        primarySx={{
                            marginBottom: 1,
                            color:  "var(--purple-dark)",
                            fontWeight: '600',
                            fontSize: '36px',
                            fontFamily: "Poppins"
                        }}
                        secondarySx={{
                            fontSize: '24px'
                        }}
                    />
                </ListItem>
                <Swiper
                    modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                    spaceBetween={2}
                    onSwiper={(swiper: any) => {
                        swiperRef.current = swiper;
                        if (isVisible) {
                        swiper.autoplay?.start();
                        }
                    }}
                    slidesPerView={matches ? 2 : 4}
                    pagination={{
                        clickable: true,
                    }}
                    style={{
                        display: 'flex',
                        textAlign: 'center',
                        maxWidth: '100%',
                        height: '230px',
                    }}
                >
                    {dados.map((data:any, index: number) => (
                        <SwiperSlide
                            key={index}
                            style={{
                                width: matches ? '50%' : '70%',
                                display: "flex",
                                alignItems: "center"
                            }}
                        >
                            <img src={data?.image} width={matches ? 120 : 180 }/>
                        </SwiperSlide>
                    ))}
                </Swiper>
                
            </Box>
        </BaseDiv>
    );
}

export { CarrouselClientes }